import React from 'react';
import PropTypes from 'prop-types';
import { LinkTextStyled, TextStyled } from './styles';

function LinkText({ to, external, target, onClick, style, children }) {
  if (external && to)
    return (
      <TextStyled style={style}>
        <a href={to} target={target ?? ''} rel={target === '_blank' ? 'noopener noreferrer' : ''}>
          {children}
        </a>
      </TextStyled>
    );
  if (!to)
    return (
      <TextStyled style={style} onClick={onClick || (() => {})}>
        {children}
      </TextStyled>
    );
  return (
    <LinkTextStyled style={style} to={to}>
      {children}
    </LinkTextStyled>
  );
}

LinkText.propTypes = {
  to: PropTypes.string,
  target: PropTypes.string,
  external: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default LinkText;
